import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useInfiniteScroll from 'react-infinite-scroll-hook';

import { GenericTabContainer } from './GenericTabContainer';
import { filterShape, tileShape } from '../shapes';

const containerTop = (status, isUserSiteAdmin) => {
  const zeroTop = ['active', 'archive'].includes(status);

  if (!isUserSiteAdmin && status === 'plan') {
    return '0';
  }

  return zeroTop ? '0' : '-25px';
};

const StyledContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  position: relative;
  top: ${props => containerTop(props.activeStatus, props.isUserSiteAdmin)};

  @media (max-width: 1300px) {
    top: inherit;
  }
`;

export const ScrollableTabContainer = ({ pageSize = 16, ...props }) => {
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    setPageNumber(1);
  }, [props.activeStatus]);

  const [loading, setLoading] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(
    props.tiles.length > pageNumber * pageSize,
  );
  const handleLoadMore = useCallback(() => {
    setLoading(true);
    setPageNumber(previousPageNumber => previousPageNumber + 1);
    setHasNextPage(props.tiles.length > pageNumber * pageSize);
    setTimeout(() => setLoading(false), 200);
  }, [pageNumber, pageSize, props.tiles.length]);

  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage,
    onLoadMore: handleLoadMore,
  });

  return (
    <StyledContainer
      activeStatus={props.activeStatus}
      isUserSiteAdmin={props.isUserSiteAdmin}
    >
      <GenericTabContainer
        activeFilters={props.activeFilters}
        activeStatus={props.activeStatus}
        changeTileStatus={props.changeTileStatus}
        handleMenuAction={props.handleMenuAction}
        hasEmptyTileFillers={props.hasEmptyTileFillers}
        isUserSiteAdmin={props.isUserSiteAdmin}
        moveTileToProof={props.moveTileToProof}
        tiles={props.tiles.slice(0, pageSize * pageNumber)}
        dndContext={props.dndContext}
        pageNumber={pageNumber}
        pageSize={pageSize}
      />
      <div ref={sentryRef} />
    </StyledContainer>
  );
};

ScrollableTabContainer.propTypes = {
  activeFilters: filterShape,
  activeStatus: PropTypes.string.isRequired,
  changeTileStatus: PropTypes.func.isRequired,
  handleMenuAction: PropTypes.func,
  hasEmptyTileFillers: PropTypes.bool,
  isUserSiteAdmin: PropTypes.bool,
  moveTileToProof: PropTypes.func,
  pageSize: PropTypes.number,
  tileContainerClick: PropTypes.func,
  tiles: PropTypes.arrayOf(tileShape),
  dndContext: PropTypes.object
};
